import React, {useEffect, useState} from 'react'
import client from "../../../axios";
import InfoModal from '../../common-modals/info-modal'
import {formatInputWithComma} from "../../../lib/converting-func";

const AutoStockAdd = () => {
	const [ inputVal, setInputVal ] = useState('')

	/* 동작 실패 시 띄울 모달의 정보 */
	const [ showFailedModal, setShowFailedModal ] = useState(false)
	const [ failedMessage, setFailedMessage ] = useState('')
	const [ failedTitle, setFailedTitle ] = useState('')

	const handleChange = async () => {
		if(inputVal === '') {
			setFailedMessage('값을 입력하세요.')
			setFailedTitle('저장 실패')
			setShowFailedModal(true)
			return
		}

		const cleanValue = inputVal.replace(/,/g, '')
		const value = Number(cleanValue)
		if(Number.isNaN(value)) {
			setFailedMessage('숫자만 입력하세요.')
			setFailedTitle('저장 실패')
			setShowFailedModal(true)
			return
		}

		try {
			const response = await client.post('/api/settings/set-auto-stock', {
				payload: { auto_stock_add: value }
			})
			if(response.data.result === 'expired') {
				setFailedMessage('세션이 만료되었습니다. 다시 로그인하세요.')
				setFailedTitle('저장 실패')
				setShowFailedModal(true)
			} else if (response.data.result === 'failed') {
				setFailedTitle('저장 실패')
				setFailedMessage('서버에 문제가 발생하였습니다.')
				setShowFailedModal(true)
			}
		} catch (e: any) {
			setShowFailedModal(true)
			setFailedTitle('저장 실패')
			setFailedMessage('통신에 에러가 발생했습니다. 인터넷 연결을 확인하세요.')
		}
	}

	useEffect(() => {
		client.get('/api/settings/get-auto-stock')
			.then(res => {
				if(res.data.result === 'expired') {
					setFailedTitle('데이터 가져오기 실패')
					setFailedMessage('세션이 만료되었습니다. 다시 로그인하세요.')
					setShowFailedModal(true)
					return
				}
				if(res.data.result === 'failed') {
					setFailedTitle('데이터 가져오기 실패')
					setFailedMessage('서버에 문제가 발생하였습니다.')
					setShowFailedModal(true)
					return
				}
				const serverVal = res.data.payload.auto_stock_add
				setInputVal(formatInputWithComma(serverVal !== null && serverVal !== undefined ? String(serverVal) : ''))
			})
			.catch(() => {
				setFailedTitle('데이터 가져오기 실패')
				setFailedMessage('통신에 에러가 발생했습니다. 인터넷 연결을 확인하세요.')
				setShowFailedModal(true)
			})
	}, [])

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const inputElement = e.target
		const rawValue = inputElement.value
		const formattedValue = formatInputWithComma(rawValue)

		const selectionStart = inputElement.selectionStart || 0
		const beforeCommaCount = (rawValue.slice(0, selectionStart).match(/,/g) || []).length
		const afterCommaCount = (formattedValue.slice(0, selectionStart).match(/,/g) || []).length
		const commaDiff = afterCommaCount - beforeCommaCount

		setInputVal(formattedValue)

		requestAnimationFrame(() => {
			const newCursorPos = selectionStart + commaDiff
			inputElement.setSelectionRange(newCursorPos, newCursorPos)
		})
	}

	return (
		<div className="mt-4 d-flex justify-content-sm-start justify-content-center" aria-label="auto-stock-add-box">
			<div className="d-inline border px-3" aria-label="auto-stock-add-field">
				<div className="input-group input-group-sm my-4">
					<span className="input-group-text password-addon">자동 재고추가 값</span>
					<input 
						className="form-control" 
						type="text" 
						value={inputVal}
						onChange={handleInputChange}
					/>
				</div>

				<div className="d-flex justify-content-end my-4">
					<button className="btn btn-primary btn-sm px-3" onClick={handleChange}>저장</button>
				</div>
			</div>

			<InfoModal show={showFailedModal} onHide={() => setShowFailedModal(false)} title={failedTitle}
					   message={failedMessage} onButtonClick={() => setShowFailedModal(false)} />
		</div>
	)
}

export default AutoStockAdd
